import Layout from '../../components/admin/Layout';
import ListPedidos from '../../components/admin/listPedidos';

const AdmPedidos = () => {
	return (
		<Layout
			pagina={"Administración de Pedidos"}
		>
			<div className='w-full p-5 min-h-full'>
                <h1 className='my-10 text-center text-3xl text-gray-700'>Administración de Pedidos</h1>
				<ListPedidos estado={0}/>
			</div>
		</Layout>
	)
}

export default AdmPedidos